import axios from 'axios';
import moment from 'moment';
import { clientAxios } from '../../configs/axios';

const API_URL = process.env.REACT_APP_API_URL;

export function getMonitoreoDevice(filters) {
  return async (dispatch) => {
    dispatch(monitoreoInit());
    try {
      const response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/tipo/dispositivo`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId : filters?.nodo || 0,
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        amarillo: false,
        criticidadId: 0,
        dispositivoId: 0,
        gris: false,
        metricaId: 0,
        rojo: false,
        servicioId: 0,
        tipoAnchoBanda: 0,
        verde: false,
      });

      const data = await response?.data;
      if (response?.status === 404 || !data) {
        dispatch(monitoreoSuccess([]));
      } else {
        const devices = {};
        data?.data.forEach((deviceData) => {
          if (devices[deviceData.tipodispositivoid]) {
            if (devices[deviceData.tipodispositivoid][deviceData.criticidadId]) {
              devices[deviceData.tipodispositivoid][deviceData.criticidadId] = {
                ...devices[deviceData.tipodispositivoid][deviceData.criticidadId],
                [deviceData.color]: deviceData.total,
              };
            } else {
              devices[deviceData.tipodispositivoid][deviceData.criticidadId] = {
                tipodispositivoid: deviceData.tipodispositivoid,
                dstipodispositivo: deviceData.dstipodispositivo,
                criticidadId: deviceData.criticidadId,
                verde: '0',
                amarillo: '0',
                rojo: '0',
                gris: '0',
                [deviceData.color]: deviceData.total,
              };
            }
          } else {
            devices[deviceData.tipodispositivoid] = {
              [deviceData.criticidadId]: {
                tipodispositivoid: deviceData.tipodispositivoid,
                dstipodispositivo: deviceData.dstipodispositivo,
                criticidadId: deviceData.criticidadId,
                verde: '0',
                amarillo: '0',
                rojo: '0',
                gris: '0',
                [deviceData.color]: deviceData.total,
              },
            };
          }
        });
        let devicesFormatted = [];
        Object.keys(devices).forEach((deviceKey) => {
          devicesFormatted = devicesFormatted.concat(devices[deviceKey]['1'], devices[deviceKey]['2']);
        });
        devicesFormatted = devicesFormatted.filter(Boolean);
        dispatch(monitoreoSuccess(devicesFormatted));
      }
    } catch (error) {
      dispatch(monitoreoError(error));
    }
  };
}

export function getMonitoreoService(filters) {
  return async (dispatch) => {
    dispatch(monitoreoInit());
    try {
      const response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/tipo/servicio`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId : filters?.nodo || 0,
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        amarillo: false,
        criticidadId: 0,
        dispositivoId: 0,
        gris: false,
        metricaId: 0,
        rojo: false,
        servicioId: 0,
        tipoAnchoBanda: 0,
        verde: false,
      });
      const data = await response?.data;
      if (response?.status === 404 || !data) {
        dispatch(monitoreoSuccessServices([]));
      } else {
        const services = {};
        data?.data.forEach((serviceData) => {
          if (services[serviceData.tiposervicioid]) {
            services[serviceData.tiposervicioid] = {
              ...services[serviceData.tiposervicioid],
              [serviceData.color]: serviceData.total,
            }
          } else {
            services[serviceData.tiposervicioid] = {
              tiposervicioid: serviceData.tiposervicioid,
              dstiposervicio: serviceData.dstiposervicio,
              verde: '0',
              amarillo: '0',
              rojo: '0',
              gris: '0',
              [serviceData.color]: serviceData.total,
            };
          }
        });
        // let servicesFormatted = [];
        // Object.values(services).forEach((deviceKey) => {
        //   servicesFormatted = servicesFormatted.concat(services[deviceKey]['1'], services[deviceKey]['2']);
        // });
        // servicesFormatted = servicesFormatted.filter(Boolean);
        dispatch(monitoreoSuccessServices(Object.values(services)));
      }
    } catch (error) {
      dispatch(monitoreoErrorServices(error));
    }
  };
}

export function getMonitoreoMetric(filters) {
  return async (dispatch) => {
    dispatch(monitoreoInit());
    try {
      const response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/totales/metrica`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId : filters?.nodo || 0,
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        amarillo: false,
        criticidadId: 0,
        dispositivoId: 0,
        gris: false,
        metricaId: 0,
        rojo: false,
        servicioId: 0,
        tipoAnchoBanda: 0,
        verde: false,
      });
      const responseAnchoBanda = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/totales/metricaanchobanda`, {
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId : filters?.nodo || 0,
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        amarillo: false,
        criticidadId: 0,
        dispositivoId: 0,
        gris: false,
        metricaId: 0,
        rojo: false,
        servicioId: 0,
        tipoAnchoBanda: 0,
        verde: false,
      });
      // let data = await response.data.data[0];
      let data = await response?.data;
      let dataAnchoBanda = await responseAnchoBanda?.data;
      if (data?.status === 404 || dataAnchoBanda?.status === 404 || !data) {
        monitoreoSuccessMetrics([]);
      } else {
        [data] = data.data;
        [dataAnchoBanda] = dataAnchoBanda.data;
        if (!Object.values(data).every((keyValue) => keyValue === null)) {
          data = [
            {
              nameLabel: 'Uso de memoria',
              verde: data.verdememoria,
              amarillo: data.amarillomemoria,
              rojo: data.rojomemoria,
              gris: data.grismemoria,
            },
            {
              nameLabel: 'Uso de CPU',
              verde: data.verdecpu,
              amarillo: data.amarillocpu,
              rojo: data.rojocpu,
              gris: data.griscpu,
            },
            {
              nameLabel: 'Latencia',
              verde: data.verdelatencia,
              amarillo: data.amarillolatencia,
              rojo: data.rojolatencia,
              gris: data.grislatencia,
            },
            {
              nameLabel: 'Perdida de paquetes',
              verde: data.verdepaquetes,
              amarillo: data.amarillopaquetes,
              rojo: data.rojopaquetes,
              gris: data.grispaquetes,
            },
            // {
            //   nameLabel: 'Temperatura',
            //   verde: data.verdetemperatura,
            //   amarillo: data.amarillotemperatura,
            //   rojo: data.rojotemperatura,
            // },
            // {
            //   nameLabel: 'Power Supply',
            //   verde: data.verdepowersupply,
            //   amarillo: data.amarillopowersupply,
            //   rojo: data.rojopowersupply,
            // },
            // {
            //   nameLabel: 'Jitter',
            //   verde: data.verdejitter,
            //   amarillo: data.amarillojitter,
            //   rojo: data.rojojitter,
            // },
            // {
            //   nameLabel: 'Utilización',
            //   verde: data.verdeutilizacion,
            //   amarillo: data.amarilloutilizacion,
            //   rojo: data.rojoutilizacion,
            // },
            {
              nameLabel: 'Disponibilidad',
              verde: data.verdedisponibilidad,
              amarillo: data.amarillodisponibilidad,
              rojo: data.rojodisponibilidad,
              gris: data.grisdisponibilidad,
            },
            // {
            //   nameLabel: 'MOS',
            //   verde: data.verdemos,
            //   amarillo: data.amarillomos,
            //   rojo: data.rojomos,
            // },
            {
              nameLabel: 'Ancho de Banda Entrada',
              verde: dataAnchoBanda.verdeanchobandaentrada || '0',
              amarillo: dataAnchoBanda.amarilloanchobandaentrada || '0',
              rojo: dataAnchoBanda.rojoanchobandaentrada || '0',
              gris: dataAnchoBanda.grisanchobandaentrada || '0',
            },
            {
              nameLabel: 'Ancho de Banda Salida',
              verde: dataAnchoBanda.verdeanchobandasalida || '0',
              amarillo: dataAnchoBanda.amarilloanchobandasalida || '0',
              rojo: dataAnchoBanda.rojoanchobandasalida || '0',
              gris: dataAnchoBanda.grisanchobandasalida || '0',
            },
          ];
          data = data.filter((metricData) => {
            if (metricData.nameLabel !== 'Estado actual del equipo') {
              if (metricData.verde === '0' && metricData.amarillo === '0' && metricData.rojo === '0') {
                return null;
              }
              return metricData;
            }
            if (metricData.verde === '0' && metricData.amarillo === '0' && metricData.rojo === '0' && metricData.gris === '0') {
              return null;
            }
            return metricData;
          });
        } else {
          data = [];
        }
        dispatch(monitoreoSuccessMetrics(data));
      }
    } catch (error) {
      dispatch(monitoreoErrorMetrics(error));
    }
  };
}

export function getNodesPerCategory(category, id, color, filters, criticidadId) {
  return async (dispatch) => {
    dispatch(monitoreoNodesInit());
    try {
      let response;
      if (category === 'service') {
        response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/detalle/tipo/servicio`, {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          nodeId : filters?.nodo || 0,
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
          servicioId: id,
          verde: color === 'verde',
          amarillo: color === 'amarillo',
          rojo: color === 'rojo',
          gris: color === 'gris',
          criticidadId: 0,
          dispositivoId: 0,
          tipoAnchoBanda: 0,
          metricaId: 0,
        });
      }
      if (category === 'device') {
        response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/detalle/tipo/dispositivo`, {
          grupoInmuebleId: filters?.grupo || 0,
          criticidadId: criticidadId || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          nodeId : filters?.nodo || 0,
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
          dispositivoId: id,
          verde: color === 'verde',
          amarillo: color === 'amarillo',
          rojo: color === 'rojo',
          gris: color === 'gris',
          tipoAnchoBanda: 0,
          metricaId: 0,
        });
      }
      if (category === 'metric') {
        response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/detalle/metricas`, {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          nodeId : filters?.nodo || 0,
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
          metricaId: id,
          verde: color === 'verde',
          amarillo: color === 'amarillo',
          rojo: color === 'rojo',
          gris: color === 'gris',
          criticidadId: 0,
          dispositivoId: 0,
          tipoAnchoBanda: 0,
          servicioId: 0,
        });
      }
      if (category === 'anchobandaentrada' || category === 'anchobandasalida') {
        response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/detalle/totales/metricaanchobanda`, {
          grupoInmuebleId: filters?.grupo || 0,
          inmuebleId: filters?.inmueble || 0,
          regionId: filters?.region || 0,
          fechaFin: filters?.fechaFin || '',
          fechaIni: filters?.fechaIni || '',
          nodeId : filters?.nodo || 0,
          // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
          // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
          tipoAnchoBanda: category === 'anchobandaentrada' ? 1 : 2,
          verde: color === 'verde',
          amarillo: color === 'amarillo',
          rojo: color === 'rojo',
          gris: color === 'gris',
          criticidadId: 0,
          dispositivoId: 0,
          metricaId: 0,
          servicioId: 0,
        });
      }

      let data = await response?.data;
      if (data?.status === 404 || !data) {
        dispatch(monitoreoSuccessNodes([]));
      } else {
        data = data.data.map((node, index) => ({ ...node, id: index }));
        dispatch(monitoreoSuccessNodes(data));
      }
    } catch (error) {
      dispatch(monitoreoErrorNodes(error));
    }
  };
}

export function setMonitoreoFiltersSelected(filtersAdded) {
  return async (dispatch) => {
    dispatch(monitoreoFiltersSelectionInit());
    try {
      if (!filtersAdded) {
        dispatch(monitoreoFiltersSelectionSuccess({}));
      } else {
        let filters = { ...filtersAdded };
        if ('tiempo' in filtersAdded) {
          if (filtersAdded.tiempo.fechaIni === 'update') {
            filters = {
              ...filters,
              // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
              // fechaIni: moment().subtract(10, 'minutes').format('Y-MM-DD HH:mm:00'),
              fechaFin: null,
              fechaIni: null,
            };
          } else {
            filters = { ...filters, ...filtersAdded.tiempo };
          }
          delete filters.tiempo;
        }
        dispatch(monitoreoFiltersSelectionSuccess(filters));
      }
    } catch (error) {
      dispatch(monitoreoFiltersSelectionError());
    }
  };
}

export function getTopologicNodes(filters) {
  return async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/ms-monitoreo/monitoreo/lista/nodos`, {
        amarillo: false,
        criticidadId: 0,
        dispositivoId: 0,
        // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
        // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
        fechaFin: filters?.fechaFin || '',
        fechaIni: filters?.fechaIni || '',
        nodeId : filters?.nodo || 0,
        gris: false,
        grupoInmuebleId: filters?.grupo || 0,
        inmuebleId: filters?.inmueble || 0,
        regionId: filters?.region || 0,
        metricaId: 0,
        rojo: false,
        servicioId: 0,
        tipoAnchoBanda: 0,
        verde: false,
      });
      let data = await response?.data;
      if (data?.status === 404 || !data) {
        monitoreoTopologicSuccessNodes([]);
      } else {
        data = data.data;
        dispatch(monitoreoTopologicSuccessNodes(data || []));
      }
    } catch (error) {
      dispatch(monitoreoTopologicErrorNodes(error));
    }
  };
}

const monitoreoInit = () => ({ type: 'VIEW_MONITOREO_INIT' });
const monitoreoError = (error) => ({ type: 'VIEW_MONITOREO_ERROR', payload: error });
const monitoreoSuccess = (data) => ({ type: 'VIEW_MONITOREO_SUCCESS', payload: data });

const monitoreoErrorServices = (error) => ({ type: 'VIEW_MONITOREO_SERVICES_ERROR', payload: error });
const monitoreoSuccessServices = (data) => ({ type: 'VIEW_MONITOREO_SERVICES_SUCCESS', payload: data });

const monitoreoErrorMetrics = (error) => ({ type: 'VIEW_MONITOREO_METRICS_ERROR', payload: error });
const monitoreoSuccessMetrics = (data) => ({ type: 'VIEW_MONITOREO_METRICS_SUCCESS', payload: data });

const monitoreoNodesInit = () => ({ type: 'VIEW_MONITOREO_NODES_INIT' });
const monitoreoSuccessNodes = (data) => ({ type: 'VIEW_MONITOREO_NODES_SUCCESS', payload: data });
const monitoreoErrorNodes = (error) => ({ type: 'VIEW_MONITOREO_NODES_ERROR', payload: error });

const monitoreoFiltersSelectionInit = () => ({ type: 'VIEW_MONITOREO_FILTERS_SELECTION_INIT' });
const monitoreoFiltersSelectionSuccess = (data) => ({ type: 'VIEW_MONITOREO_FILTERS_SELECTION_SUCCESS', payload: data });
const monitoreoFiltersSelectionError = (error) => ({ type: 'VIEW_MONITOREO_FILTERS_SELECTION_ERROR', payload: error });

const monitoreoTopologicNodesInit = () => ({ type: 'VIEW_MONITOREO_TOPOLOGIC_NODES_INIT' });
const monitoreoTopologicSuccessNodes = (data) => ({ type: 'VIEW_MONITOREO_TOPOLOGIC_NODES_SUCCESS', payload: data });
const monitoreoTopologicErrorNodes = (error) => ({ type: 'VIEW_MONITOREO_TOPOLOGIC_NODES_ERROR', payload: error });

const initialState = {
  name: 'monitoreo',
  state: false,
  loading: true,
  services: [],
  monitoreo: [],
  metrics: [],
  loadingNodes: false,
  nodes: [],
  devices:[],
  filtersSelected: {
    // fechaFin: moment().format('Y-MM-DD HH:mm:00'),
    // fechaIni: moment().subtract(5, 'minutes').format('Y-MM-DD HH:mm:00'),
    fechaFin: null,
    fechaIni: null,
  },
  topologicNodes: [],
};

export default function init(state = initialState, action) {
  switch (action.type) {
    case 'VIEW_MONITOREO_INIT':
      return {
        ...state,
        state: false,
        loading: true,
      };
    case 'VIEW_MONITOREO_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        monitoreo: action.payload,
      };
    case 'VIEW_MONITOREO_ERROR':
      return {
        ...state,
        state: true,
        loading: false,
        error: action.payload,
      };
    case 'VIEW_MONITOREO_SERVICES_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        services: action.payload,
      };
    case 'VIEW_MONITOREO_SERVICES_ERROR':
      return {
        ...state,
        state: true,
        loading: false,
        error: action.payload,
      };
    case 'VIEW_MONITOREO_METRICS_SUCCESS':
      return {
        ...state,
        state: true,
        loading: false,
        metrics: action.payload,
      };
    case 'VIEW_MONITOREO_METRICS_ERROR':
      return {
        ...state,
        state: true,
        loading: false,
        metrics: [],
        error: action.payload,
      };
    case 'VIEW_MONITOREO_NODES_INIT':
      return {
        ...state,
        loadingNodes: true,
      };
    case 'VIEW_MONITOREO_NODES_SUCCESS':
      return {
        ...state,
        loadingNodes: false,
        nodes: action.payload,
      };
    case 'VIEW_MONITOREO_NODES_ERROR':
      return {
        ...state,
        loadingNodes: false,
        error: action.payload,
        nodes: [],
      };
    case 'VIEW_MONITOREO_FILTERS_SELECTION_SUCCESS':
      return {
        ...state,
        filtersSelected: action.payload,
      };
    case 'VIEW_MONITOREO_TOPOLOGIC_NODES_SUCCESS':
      return {
        ...state,
        topologicNodes: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
